export const zh = {
  // Navigation (Chinese)
  explore: '探索',
  search: '搜索',
  create: '创建帖子',
  messages: '消息',
  notifications: '通知',
  settings: '设置',
  profile: '个人资料',
  logout: '退出登录',
  home: '首页',
  
  // Authentication
  signin: '登录',
  signup: '注册',
  login: '登录',
  register: '注册',
  email: '邮箱',
  password: '密码',
  confirmPassword: '确认密码',
  firstName: '名',
  lastName: '姓',
  forgotPassword: '忘记密码？',
  alreadyHaveAccount: '已有账户？登录',
  dontHaveAccount: '没有账户？注册',
  
  // Posts & Content
  recent: '最新',
  trending: '热门',
  popular: '流行',
  like: '点赞',
  likes: '点赞',
  comment: '评论',
  comments: '评论',
  share: '分享',
  delete: '删除',
  edit: '编辑',
  post: '帖子',
  posts: '帖子',
  title: '标题',
  content: '内容',
  tags: '标签',
  noBlogsFound: '未找到博客。尝试搜索其他内容或创建第一个！',
  
  // AI Assistant
  quickActions: '快速操作',
  writeCaption: '写标题',
  suggestTopics: '建议主题',
  improveContent: '改进内容',
  creativeIdeas: '创意想法',
  clearChat: '清除聊天',
  aiWritingAssistant: 'AI写作助手',
  poweredByGroq: '由GROQ AI驱动',
  aiGreeting: '你好！我是你的AI写作助手。我可以帮助你创建引人入胜的内容、写标题、建议帖子主题并改进你的写作。今天你想要处理什么？',
  askMeToHelp: '请我帮助内容、标题、主题或写作...',
  aiThinking: 'AI正在思考...',
  
  // Chat & Messages
  chat: '聊天',
  noConversationsYet: '还没有对话',
  ideafluxChat: 'IdeaFlux聊天',
  typeMessage: '输入消息...',
  sendMessage: '发送消息',
  connectingToChat: '连接到聊天...',
  
  // Notifications
  noNotificationsYet: '还没有通知。',
  markAllRead: '全部标记为已读',
  clearAll: '全部清除',
  
  // Settings
  accountSettings: '账户设置',
  displayName: '显示名称',
  emailAddress: '邮箱地址',
  languagePreference: '语言偏好',
  privacySecurity: '隐私与安全',
  notificationPreferences: '通知偏好',
  allowDirectMessages: '允许私信',
  letOthersMessage: '允许其他用户向你发送私信',
  likesOnPosts: '帖子点赞',
  commentsOnPosts: '帖子评论',
  newFollowers: '新关注者',
  mentions: '提及',
  save: '保存',
  deleteAccount: '删除账户',
  
  // Notification descriptions
  getNotifiedWhenSomeone: '当有人执行以下操作时接收通知',
  likesYourPosts: '点赞你的帖子',
  commentsOnYourPosts: '评论你的帖子',
  followsYou: '关注你',
  mentionsYou: '提及你',
  chooseNotifications: '选择你想要接收的通知',
  controlWhoInteracts: '控制谁可以与你互动',
  manageAccountInfo: '管理你的账户信息和偏好',
  emailCannotBeChanged: '出于安全考虑，邮箱无法更改',
  
  // Common
  loading: '加载中...',
  cancel: '取消',
  update: '更新',
  submit: '提交',
  back: '返回',
  next: '下一个',
  previous: '上一个',
  online: '在线',
  offline: '离线',
  
  // Profile
  editProfile: '编辑个人资料',
  noBioYet: '还没有个人简介。',
  followers: '关注者',
  following: '关注中',
  recentActivity: '最近活动',
  noPostsYet: '还没有帖子',
  shareFirstPost: '分享你的第一个帖子！',
  bio: '个人简介',
  dateOfBirth: '出生日期',
  follow: '关注',
  unfollow: '取消关注',
  
  // Search
  discover: '发现',
  findPeopleStories: '找到对你重要的人、故事和想法',
  searchByName: '按姓名、标题或#标签搜索...',
  searchResults: '搜索结果',
  noResultsFound: '未找到结果',
  peopleFound: '找到的人',
  
  // Settings - Additional keys
  enterDisplayName: '输入你的显示名称',
  saving: '保存中...',
  confirmDeleteAccount: '你确定要删除你的账户吗？此操作无法撤销。',
  accountDeletedSuccessfully: '账户删除成功。',
  errorDeletingAccount: '删除账户时出错。请重试。',
  settingsSavedSuccessfully: '设置保存成功！',
  failedToSaveSettings: '保存设置失败。请重试。',
  
  // Form component
  pleaseSignInToCreate: '请登录以创建帖子。',
  titleRequired: '发布帖子需要标题。',
  contentRequired: '发布帖子需要故事内容。',
  contentTooShort: '故事内容必须至少10个字符长。',
  postUpdatedSuccessfully: '帖子更新成功！',
  postPublishedSuccessfully: '帖子发布成功！',
  pleaseSignInToCreateBlogs: '请登录以创建你自己的IdeaFlux博客。',
  enterEngagingTitle: '输入引人入胜的标题...',
  story: '故事',
  writeYourMasterpiece: '写下你的杰作...',
  addTags: '添加标签...',
  add: '添加',
  publishPost: '发布帖子',
  
  // Post component
  linkCopiedToClipboard: '链接已复制到剪贴板！分享计数已更新。',
  youAndOthers: '你和其他{{count}}人',
  unknownUser: '未知用户',
  noImage: '无图片',
  deletePost: '删除帖子',
  confirmDeletePost: '你确定要删除这个帖子吗？',
};